/**
 * Sizing Calculator - Vanilla JS
 * Range matching: height/weight within row ranges, outputs size_primary or size_secondary by fit.
 * Multiple instances supported via .scalc root nodes.
 */
(function () {
  'use strict';

  function parseJson(el) {
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return null;
    }
  }

  /**
   * Range matching: row matches when
   * height >= min_height_cm AND (max_height_cm is null OR height <= max_height_cm)
   * weight >= min_weight_kg AND (max_weight_kg is null OR weight <= max_weight_kg)
   * If multiple matches: use first (rows assumed ordered by specificity).
   */
  function findMatchingRow(rows, height, weight) {
    if (!Array.isArray(rows) || rows.length === 0) return null;
    for (let i = 0; i < rows.length; i++) {
      const r = rows[i];
      const hOk = height >= (r.minHeightCm || 0) && (r.maxHeightCm == null || height <= r.maxHeightCm);
      const wOk = weight >= (r.minWeightKg || 0) && (r.maxWeightKg == null || weight <= r.maxWeightKg);
      if (hOk && wOk) return r;
    }
    return null;
  }

  function initCalculator(root) {
    const jsonEl = root.querySelector('script[data-scalc-json]');
    const form = root.querySelector('[data-scalc-form]');
    const resultEl = root.querySelector('[data-scalc-result]');

    if (!jsonEl || !form || !resultEl) return;

    const data = parseJson(jsonEl);
    const emptyMsg = root.getAttribute('data-scalc-empty-msg') || 'Keine Größentabelle hinterlegt – bitte Shop kontaktieren.';
    if (!data || !data.rows || data.rows.length === 0) {
      resultEl.setAttribute('data-scalc-has-result', 'false');
      resultEl.textContent = emptyMsg;
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        resultEl.textContent = emptyMsg;
      });
      return;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      const heightInput = root.querySelector('[data-scalc-height]');
      const weightInput = root.querySelector('[data-scalc-weight]');

      if (!heightInput || !weightInput) return;

      const height = parseInt(heightInput.value, 10);
      const weight = parseInt(weightInput.value, 10);

      if (isNaN(height) || height < 120 || height > 230) {
        resultEl.setAttribute('data-scalc-has-result', 'false');
        resultEl.textContent = 'Bitte Körpergröße zwischen 120 und 230 cm eingeben.';
        return;
      }
      if (isNaN(weight) || weight < 35 || weight > 200) {
        resultEl.setAttribute('data-scalc-has-result', 'false');
        resultEl.textContent = 'Bitte Gewicht zwischen 35 und 200 kg eingeben.';
        return;
      }

      const row = findMatchingRow(data.rows, height, weight);

      if (!row) {
        resultEl.setAttribute('data-scalc-has-result', 'false');
        resultEl.textContent = 'Keine Empfehlung gefunden – bitte Support kontaktieren.';
        return;
      }

      const fitLabels = data.fitLabels || {};
      const primaryLabel = fitLabels.primary || '';
      const secondaryLabel = fitLabels.secondary || '';
      const sizePrimary = row.sizePrimary || '';
      const sizeSecondary = row.sizeSecondary || '';

      var parts = [];
      if (sizePrimary) parts.push(sizePrimary + (primaryLabel ? ' (' + primaryLabel + ')' : ''));
      if (sizeSecondary) parts.push(sizeSecondary + (secondaryLabel ? ' (' + secondaryLabel + ')' : ''));
      var orStr = root.getAttribute('data-scalc-result-or') || ' oder ';
      var prefix = parts.length > 1
        ? (root.getAttribute('data-scalc-result-prefix-plural') || 'Empfohlene Größen')
        : (root.getAttribute('data-scalc-result-prefix') || 'Empfohlene Größe');
      var msg = prefix + ': ' + parts.join(orStr);

      resultEl.setAttribute('data-scalc-has-result', 'true');
      resultEl.textContent = msg;
    });
  }

  function init() {
    const roots = document.querySelectorAll('.scalc[data-scalc-root]');
    roots.forEach(initCalculator);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
